import React from 'react';
import { ExtraParameterModel, extraParameterModelInitial } from '../../../Models/ExtraParameterModel';
import { IExtraParameterFieldType } from './model/ExtraParameterFieldType';

export interface IClientExtraParameterContextProps {
    currentExtraParameter: ExtraParameterModel
    setCurrentExtraParameter: (value: ExtraParameterModel) => void    
    selectedExtraParameterFieldType: IExtraParameterFieldType | null
    setSelectedExtraParameterFieldType: (value: IExtraParameterFieldType | null) => void    
    actionFieldIndex: number
    setActionFieldIndex: (value: number) => void    
    isInEditMode: boolean
    setIsInEditMode: (value: boolean) => void    
}

export const ClientExtraParameterContextInitial: IClientExtraParameterContextProps = {
    currentExtraParameter: extraParameterModelInitial,
    setCurrentExtraParameter: () => { ''; },
    selectedExtraParameterFieldType: null,
    setSelectedExtraParameterFieldType: () => { ''; },
    actionFieldIndex: -1,
    setActionFieldIndex: () => { ''; },
    isInEditMode: false,
    setIsInEditMode: () => { ''; },
};

export const ClientExtraParameterContext = React.createContext(ClientExtraParameterContextInitial);